var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, put, select, takeLatest, } from 'redux-saga/effects';
import { getJrniCategoryId, getJrniGrandParentId, } from '../utils';
import { runActionAfterDelay } from '../utils/sagas';
import { ActionTypes, actions } from './actions';
import { fetchCategories, fetchCategoryImage } from './requests';
import { processCategories, processImage } from './utils';
export function loadCategories() {
    var jrniCategoryId_1, jrniGrandparentId_1, categoriesResponse, categories, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, select(getJrniCategoryId)];
            case 1:
                jrniCategoryId_1 = _a.sent();
                return [4 /*yield*/, select(getJrniGrandParentId)];
            case 2:
                jrniGrandparentId_1 = _a.sent();
                return [4 /*yield*/, call(fetchCategories, jrniGrandparentId_1, jrniCategoryId_1)];
            case 3:
                categoriesResponse = _a.sent();
                categories = processCategories(categoriesResponse);
                return [4 /*yield*/, all(categories.map(function (category) {
                        var imageResponse, imageUrl;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, call(fetchCategoryImage, jrniGrandparentId_1, jrniCategoryId_1, category.key)];
                                case 1:
                                    imageResponse = _a.sent();
                                    imageUrl = processImage(imageResponse);
                                    return [2 /*return*/, __assign(__assign({}, category), { image: imageUrl })];
                            }
                        });
                    }))];
            case 4:
                data = _a.sent();
                return [4 /*yield*/, put(actions.loadCategoriesSuccess(data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _a.sent();
                return [4 /*yield*/, put(actions.loadCategoriesFailure(error_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.LOAD_CATEGORIES, loadCategories)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_CATEGORIES_FAILURE, function () {
                        return runActionAfterDelay(actions.removeCategoriesError());
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
